import request from "@/utils/request";
const api = {
  getConstructionMaterialList: "/dsmcore/api/constructionMaterial/list", //查询施工物料
  constructionMaterialListAdd: "/dsmcore/api/constructionMaterial/add", //添加施工物料
  constructionMaterialListUpdate: "/dsmcore/api/constructionMaterial/update", //更新施工物料
  constructionMaterialChangeSupplier: "/dsmcore/api/constructionMaterial/changeSupplier", //变更供应商

  getConstructionOrderById: "/dsmcore/api/constructionOrder/getById", //获取订单信息
  getConstructionOrderList: "/dsmcore/api/constructionOrder/list", //获取订单列表
  constructionOrderAddBatch: "/dsmcore/api/constructionOrder/addBatch", //批量添加订单
  constructionOrderAdd: "/dsmcore/api/constructionOrder/add", //添加订单
  constructionOrderUpdate: "/dsmcore/api/constructionOrder/update", //更新订单
  constructionOrderDelete: "/dsmcore/api/constructionOrder/delete", //删除订单
  constructionOrderReview: "/dsmcore/api/constructionOrder/review", //订单审核接口
  constructionOrderChangeSupplier: "/dsmcore/api/constructionOrder/changeSupplier", //变更供应商
  constructionOrderConvertToOfficial: "/dsmcore/api/constructionOrder/convertToOfficialOrder", //转化为正式单
  constructionOrderRefundOrder: "/dsmcore/api/constructionOrder/refundOrder", //退货接口

  getConstructionOrderTodoCount: "/dsmcore/api/constructionOrder/todoCount", //获取待审核订单数量

  getLogisticsById: "/scmcore/api/logistics/query", //根据id查询物流订单
  getLogisticsList: "/scmcore/api/logistics/page", //查询物流订单
  logisticsListAdd: "/scmcore/api/logistics/add", //添加物流订单
  logisticsListUpdate: "/scmcore/api/logistics/update", //修改物流订单
  logisticsListDelete: "/scmcore/api/logistics/delete", //删除物流订单
  logisticsReturn: "/scmcore/api/logistics/return", //物流退货接口
};
//#region 施工物料管理 
export function GetConstructionMaterialList(parameter) {
  return request({
    url: api.getConstructionMaterialList,
    method: "get",
    params: parameter,
  });
}
export function ConstructionMaterialListAdd(parameter) {
  return request({
    url: api.constructionMaterialListAdd,
    method: "post",
    data: parameter,
  });
}
export function ConstructionMaterialListUpdate(parameter) {
  return request({
    url: api.constructionMaterialListUpdate,
    method: "post",
    data: parameter,
  });
}
export function ConstructionMaterialListDelete(parameter) {
  return request({
    url: api.constructionMaterialListDelete,
    method: "get",
    params: parameter,
  });
}
export function ConstructionMaterialChangeSupplier(parameter) {
  return request({
    url: api.constructionMaterialChangeSupplier,
    method: "get",
    params: parameter,
  });
}
//#endregion 施工物料管理

//#region 物料订单管理 
export function GetConstructionOrderById(parameter) {
  return request({
    url: api.getConstructionOrderById,
    method: "post",
    params: parameter,
  });
}
export function GetConstructionOrderList(parameter) {
  return request({
    url: api.getConstructionOrderList,
    method: "post",
    params: parameter,
  });
}
export function ConstructionOrderAddBatch(parameter) {
  return request({
    url: api.constructionOrderAddBatch,
    method: "post",
    data: parameter,
  });
}
export function ConstructionOrderAdd(parameter) {
  return request({
    url: api.constructionOrderAdd,
    method: "post",
    data: parameter,
  });
}
export function ConstructionOrderUpdate(parameter) {
  return request({
    url: api.constructionOrderUpdate,
    method: "post",
    data: parameter,
  });
}
export function ConstructionOrderDelete(parameter) {
  return request({
    url: api.constructionOrderDelete,
    method: "post",
    params: parameter,
  });
}
export function ConstructionOrderReview(parameter) {
  return request({
    url: api.constructionOrderReview,
    method: "post",
    params: parameter,
  });
}
export function ConstructionOrderChangeSupplier(parameter) {
  return request({
    url: api.constructionOrderChangeSupplier,
    method: "post",
    params: parameter,
  });
}
export function ConstructionOrderConvertToOfficial(parameter) {
  return request({
    url: api.constructionOrderConvertToOfficial,
    method: "post",
    params: parameter,
  });
}
export function ConstructionOrderRefundOrder(parameter) {
  return request({
    url: api.constructionOrderRefundOrder,
    method: "post",
    data: parameter,
  });
}
//#endregion 物料订单管理

export function GetConstructionOrderTodoCount(parameter) {
  return request({
    url: api.getConstructionOrderTodoCount,
    method: "post",
    params: parameter,
  });
}

//#region 物流订单管理 
export function GetLogisticsById(parameter) {
  return request({
    url: api.getLogisticsById,
    method: "post",
    params: parameter,
  });
}
export function GetLogisticsList(parameter) {
  return request({
    url: api.getLogisticsList,
    method: "post",
    data: parameter,
  });
}
export function LogisticsListAdd(parameter) {
  return request({
    url: api.logisticsListAdd,
    method: "post",
    data: parameter,
  });
}
export function LogisticsListUpdate(parameter) {
  return request({
    url: api.logisticsListUpdate,
    method: "post",
    data: parameter,
  });
}
export function LogisticsListDelete(parameter) {
  return request({
    url: api.logisticsListDelete,
    method: "post",
    params: parameter,
  });
}
export function LogisticsReturn(parameter) {
  return request({
    url: api.logisticsReturn,
    method: "post",
    data: parameter,
  });
}
//#endregion 物流订单管理

